// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"FV-z","categoryName":"GV-z","categoryNameSearchHeader":"HV-z","categoryContent":"IV-z","bottomAligned":"JV-z","image":"KV-z","imageNoBackground":"LV-z"};